import View from '../View';

type Props = {};

const FormLayout = ({ children }: React.PropsWithChildren<Props>) => (
  <View sx={{ '& > *:not(:first-child)': { marginTop: 4 } }}>{children}</View>
);

export default FormLayout;
